/* Mighty Pumps — site behavior. No dependencies.
   The cart uses Shopify's Ajax Cart API, so the drawer, the /cart page and checkout share one real cart. */
(function () {
  "use strict";

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";

  function money(cents) { return "$" + (cents / 100).toFixed(2); }
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $all(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function json(url, body) {
    return fetch(root + url, body ? {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify(body)
    } : { headers: { "Accept": "application/json" } }).then(function (r) {
      return r.json().then(function (data) { if (!r.ok) throw data; return data; });
    });
  }

  /* ---------- Announcement bar: rotate offers on small screens ---------- */
  $all("[data-announcement]").forEach(function (bar) {
    var items = bar.querySelectorAll(".mp-announcement__item");
    if (items.length < 2) return;
    var i = 0;
    setInterval(function () {
      items[i].classList.remove("is-active");
      i = (i + 1) % items.length;
      items[i].classList.add("is-active");
    }, 3200);
  });

  /* ---------- Drawers (mobile menu + cart) ---------- */
  var openDrawer = null, lastFocus = null;
  function setDrawer(drawer, open) {
    if (!drawer) return;
    drawer.classList.toggle("is-open", open);
    drawer.setAttribute("aria-hidden", String(!open));
    document.body.style.overflow = open ? "hidden" : "";
    if (open) {
      lastFocus = document.activeElement;
      openDrawer = drawer;
      var close = drawer.querySelector("[data-drawer-close]");
      if (close) close.focus();
    } else {
      openDrawer = null;
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }
  }
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && openDrawer) setDrawer(openDrawer, false);
  });

  var menu = $("[data-drawer]");
  if (menu) {
    $all("[data-drawer-open]").forEach(function (b) {
      b.addEventListener("click", function () { setDrawer(menu, true); b.setAttribute("aria-expanded", "true"); });
    });
    $all("[data-drawer-close], nav a", menu).forEach(function (el) {
      el.addEventListener("click", function () {
        setDrawer(menu, false);
        $all("[data-drawer-open]").forEach(function (b) { b.setAttribute("aria-expanded", "false"); });
      });
    });
  }

  /* ---------- Cart (Shopify Ajax Cart API) ---------- */
  var cartEl = $("[data-cart]");
  var cart = null;

  function bundleInfo(n) {
    if (n >= 4) return { saved: 9, text: "Buy 4, Save $9 unlocked." };
    if (n === 3) return { saved: 6, text: "Buy 3, Save $6 unlocked. Add 1 more bag to save $9." };
    if (n === 2) return { saved: 3, text: "Buy 2, Save $3 unlocked. Add 1 more bag to save $6." };
    if (n === 1) return { saved: 0, text: "Add 1 more bag to save $3." };
    return { saved: 0, text: "Buy 2, save $3 · Buy 3, save $6 · Buy 4, save $9" };
  }

  function renderCart() {
    var n = cart ? cart.item_count : 0;
    $all("[data-cart-count]").forEach(function (el) {
      el.textContent = n;
      el.classList.toggle("has-items", n > 0);
    });
    $all("[data-cart-open]").forEach(function (b) {
      b.setAttribute("aria-label", "Open cart, " + n + (n === 1 ? " item" : " items"));
    });
    if (!cartEl || !cart) return;

    var list = $("[data-cart-items]", cartEl);
    list.innerHTML = "";
    cart.items.forEach(function (line) {
      var li = document.createElement("li");
      li.className = "cart-line";
      li.innerHTML =
        '<a class="cart-line__img" href=""><img src="" alt=""></a>' +
        '<div class="cart-line__info">' +
          '<a class="cart-line__title" href=""></a>' +
          '<span class="cart-line__price">' + money(line.original_price) + '</span>' +
          '<div class="cart-line__controls">' +
            '<div class="qty qty--sm">' +
              '<button type="button" data-cart-step="-1">−</button>' +
              '<span aria-live="polite">' + line.quantity + '</span>' +
              '<button type="button" data-cart-step="1">+</button>' +
            '</div>' +
            '<button type="button" class="cart-line__remove" data-cart-remove>Remove</button>' +
          '</div>' +
        '</div>' +
        '<span class="cart-line__total">' + money(line.original_line_price) + '</span>';
      $all("a", li).forEach(function (a) { a.href = line.url; });
      var img = $("img", li);
      if (line.image) img.src = line.image + (line.image.indexOf("?") > -1 ? "&" : "?") + "width=200"; else img.remove();
      $(".cart-line__title", li).textContent = line.product_title;
      $all("[data-cart-step]", li).forEach(function (b) {
        var step = parseInt(b.dataset.cartStep, 10);
        b.setAttribute("aria-label", (step > 0 ? "Increase" : "Decrease") + " quantity of " + line.product_title);
        b.addEventListener("click", function () { changeQty(line.key, line.quantity + step); });
      });
      var remove = $("[data-cart-remove]", li);
      remove.setAttribute("aria-label", "Remove " + line.product_title);
      remove.addEventListener("click", function () { changeQty(line.key, 0); });
      list.appendChild(li);
    });

    var empty = cart.item_count === 0;
    $("[data-cart-empty]", cartEl).hidden = !empty;
    $("[data-cart-footer]", cartEl).hidden = empty;
    var b = bundleInfo(n);
    $("[data-cart-bundle]", cartEl).textContent = b.text;
    var meter = $("[data-cart-meter]", cartEl);
    if (meter) meter.style.width = Math.min(n, 4) / 4 * 100 + "%";
    $("[data-cart-subtotal]", cartEl).textContent = money(cart.original_total_price);
    // Show Shopify's real discount when the cart already has it; otherwise the bundle estimate
    var saved = cart.total_discount > 0 ? cart.total_discount : b.saved * 100;
    var savingsRow = $("[data-cart-savings-row]", cartEl);
    savingsRow.hidden = saved === 0;
    $("[data-cart-savings-label]", cartEl).textContent = cart.total_discount > 0 ? "Bundle savings" : "Bundle savings (applied at checkout)";
    $("[data-cart-savings]", cartEl).textContent = "−" + money(saved);
    var checkout = $("[data-cart-checkout]", cartEl);
    checkout.disabled = empty;
  }

  function refreshCart() {
    return json("cart.js").then(function (c) { cart = c; renderCart(); }).catch(function () {});
  }

  function changeQty(key, qty) {
    json("cart/change.js", { id: key, quantity: Math.max(0, Math.min(99, qty)) })
      .then(function (c) { cart = c; renderCart(); })
      .catch(refreshCart);
  }

  function addToCart(variantId, qty, btn) {
    if (btn) btn.setAttribute("aria-busy", "true");
    json("cart/add.js", { items: [{ id: variantId, quantity: qty }] })
      .then(refreshCart)
      .then(function () { setDrawer(cartEl, true); })
      .catch(function (err) { showToast("Couldn't add to cart", (err && (err.description || err.message)) || "Please try again."); })
      .then(function () { if (btn) btn.removeAttribute("aria-busy"); });
  }

  $all("[data-add-to-cart]").forEach(function (btn) {
    if (btn.disabled) return;
    btn.addEventListener("click", function (e) {
      e.preventDefault();
      var qtyInput = btn.hasAttribute("data-use-qty") ? $("[data-qty-input]") : null;
      var qty = qtyInput ? Math.max(1, Math.min(99, parseInt(qtyInput.value, 10) || 1)) : 1;
      addToCart(parseInt(btn.dataset.variantId, 10), qty, btn);
    });
  });

  $all("[data-cart-open]").forEach(function (b) {
    b.addEventListener("click", function (e) {
      if (!cartEl) return; // falls back to the /cart link
      e.preventDefault();
      refreshCart();
      setDrawer(cartEl, true);
    });
  });
  if (cartEl) {
    $all("[data-drawer-close]", cartEl).forEach(function (el) {
      el.addEventListener("click", function () { setDrawer(cartEl, false); });
    });
  }
  // Keep the count right after back/forward navigation or changes in another tab
  window.addEventListener("pageshow", refreshCart);
  document.addEventListener("visibilitychange", function () { if (!document.hidden) refreshCart(); });

  /* ---------- Toast ---------- */
  var toast = $("[data-toast]"), toastTimer;
  function showToast(title, text) {
    if (!toast) return;
    $("[data-toast-title]", toast).textContent = title;
    $("[data-toast-text]", toast).textContent = text;
    toast.classList.add("is-visible");
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toast.classList.remove("is-visible"); }, 3600);
  }
  if (toast) {
    $("[data-toast-close]", toast).addEventListener("click", function () { toast.classList.remove("is-visible"); });
    if ($("[data-newsletter-done]")) showToast("Thanks for signing up", "You're on the Pump List.");
  }

  /* ---------- Quantity stepper (product page) ---------- */
  $all("[data-qty]").forEach(function (wrap) {
    var input = $("input", wrap);
    $all("[data-qty-step]", wrap).forEach(function (b) {
      b.addEventListener("click", function () {
        var v = (parseInt(input.value, 10) || 1) + parseInt(b.dataset.qtyStep, 10);
        input.value = Math.min(99, Math.max(1, v));
      });
    });
  });

  /* ---------- Product gallery thumbnails ---------- */
  $all("[data-gallery]").forEach(function (g) {
    var main = $("[data-gallery-main]", g);
    $all("[data-gallery-thumb]", g).forEach(function (thumb) {
      thumb.addEventListener("click", function () {
        $all("[data-gallery-thumb]", g).forEach(function (t) { t.setAttribute("aria-current", "false"); });
        thumb.setAttribute("aria-current", "true");
        main.style.opacity = 0;
        setTimeout(function () {
          main.removeAttribute("srcset");
          main.src = thumb.dataset.src;
          main.alt = $("img", thumb).alt;
          main.style.opacity = 1;
        }, 150);
      });
    });
  });

  /* ---------- Reveal on scroll ---------- */
  function initReveal(scope) {
    var reveals = $all(".reveal:not(.is-in)", scope);
    if ("IntersectionObserver" in window && !window.Shopify?.designMode) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add("is-in"); io.unobserve(e.target); }
        });
      }, { rootMargin: "0px 0px -8% 0px" });
      reveals.forEach(function (el) { io.observe(el); });
    } else {
      reveals.forEach(function (el) { el.classList.add("is-in"); });
    }
  }
  initReveal(document);
  // Theme editor: show sections immediately when they're added or changed
  document.addEventListener("shopify:section:load", function (e) { initReveal(e.target); });
})();
